import type { ReactNode } from 'react'

import { cva } from 'class-variance-authority'

import { CountdownVariant } from '.'

// Define color variants based on urgency level using class-variance-authority
export const countdownVariants = cva('', {
  variants: {
    variant: {
      default: 'text-secondary fill-secondary',
      warning: `
                  text-moment-orange-700
                  dark:text-moment-orange-400
                  fill-moment-orange-700
                  dark:fill-moment-orange-400
        `,
      danger: `
                  text-moment-red-700
                  dark:text-moment-red-300
                  fill-moment-red-700
                  dark:fill-moment-red-300
        `,
    },
  },
})

export const CountdownTimerContainer = ({
  children,
  variant = CountdownVariant.Default,
}: {
  children: ReactNode
  variant?: CountdownVariant
}) => {
  return (
    <div
      className={`tabular-nums flex items-center gap-1 ${countdownVariants({
        variant,
      })}`}
    >
      {children}
    </div>
  )
}
